<template>
  <!-- 城市支用查询 -->
  <div>
    <app-page>
      <template #fheader>
        <div class="fan-search margin-bottom-8">
          <jr-search2
            ref="searchForm"
            :form-list="formList"
            :search-value.sync="queryForm"
            :loading="loading"
            @search="handleSearch"
            @reset="handleReset"
            trackCode='baibuBillDisburseList-1'
          >
            <template slot="batch-search-btn">
              <el-button type="primary" :size="formSize" :loading="loading" @click="handleBatchSearch()">
                批量查询
              </el-button>
            </template>
          </jr-search2>
        </div>
      </template>
      <template #header>
        <div class="fan-search">
          <page-select-groups :search-value.sync="queryForm" @change="refreshList" :selectList="selectList" />
          <div class="fan-search-col fan-search-right" v-if="$has('BBZQGL-CSZYCX-DC')">
            <!-- 表格数据配置 -->
            <jr-columns-config
              :columnsKey="columnsKey"
              :tableColumn="tableColumn"
              :selectTableColumn="selectTableColumn"
              @confirm="handleConfirm"
            />
            <page-export-button
              buttonText="报表导出"
              exportServe="fin_ap_city_tradeList_export"
              :total="total"
              :isLimit="true"
              :exportParams="exportParams"
              trackCode='baibuBillDisburseList-3'
            />
          </div>
        </div>
      </template>
      <template #main="{ height }">
        <jr-table
          :height="height"
          :key="height"
          :loading="loading"
          :tableData="list"
          :tableColumn="selectTableColumn"
          ref="baibuBillDisburseListRef"
        >
          <!-- 流水类型: RECEIPT 支用流水,REFUND 退款流水 -->
          <template #applyTypeSlotName="{row}">
            <span :class="{'text-red': isTextRed(row.receiptAmount)}">{{row.applyTypeDesc}}</span>
          </template>
          <!-- 收款单金额 -->
          <template #receiptAmountSlotName="{row}">
            <span :class="{'text-red': isTextRed(row.receiptAmount)}">{{row.receiptAmount | toFenThousandsAndFloat}}</span>
          </template>
        </jr-table>
      </template>
      <template #ffooter>
        <pagination
          :total="total"
          :current-page="queryForm.page"
          :size="queryForm.limit"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </template>
    </app-page>
    <!-- 批量搜索 -->
    <batch-search
      :visible.sync="isBatchSearchShow"
      :type-list="batchSearchTypeList"
      :loading="loading"
      @confirm="handleBatchSearchConfirm"
      trackCode='baibuBillDisburseList-2'
    />
  </div>
</template>

<script>
import { getTradeList } from '@/api/baibu-bill';
import { setStatusColor } from '@/filters/index';
import { getMonthDate } from '@/utils/date';

const queryFormDefault = {
  timeType: '1', // 时间类型
  beginTime: '', // 开始时间
  endTime: '', // 结束时间
  page: 1,
  limit: 20,
  cityNo: '', // 归属城市
  repaymentStatus: '', // 回款状态: NOT_REPAID 未回款,FULLY_REPAID 已回款
  applyType: '', // 流水类型: RECEIPT 支用流水,REFUND 退款流水
  searchContent: '', // 搜索内容-不支持模糊查询,批量查询时以逗号分隔
  searchType: '1', // 搜索类型：1-业务订单号,2-收款单号,3-申请单号,4-客户名称,5-客户编号

  searchBatchContent: '', // 处理批量查询时-搜索内容
  searchBatchType: '1', // 处理批量查询时-搜索类型
};

export default {
  name: 'BaibuBillDisburseList',
  data() {
    const optionsList = [
      { value: '1', label: '业务订单编号' },
      { value: '2', label: '收款单编号' },
      { value: '3', label: '申请编号' },
      { value: '4', label: '客户名称' },
      { value: '5', label: '客户编号' },
    ];
    return {
      loading: false,
      queryForm: JSON.parse(JSON.stringify(queryFormDefault)),
      list: [],
      total: 0,
      formList: [
        {
          prop: 'timeType',
          component: 'select-date-picker',
          options: [
            { label: '创建时间', value: '1' },
          ],
        },
        {
          prop: 'searchType',
          contentProp: 'searchContent',
          component: 'search-input-select',
          attrs: {
            type: 'text',
            placeholder: '请输入内容',
          },
          options: optionsList,
        },
      ],
      selectList: [
        {
          title: '归属城市',
          prop: 'cityNo',
          dictionaryPath: '/finance/finance-receipt/CreditCity',
        },
        {
          title: '流水类型',
          prop: 'applyType',
          dictionaryPath: '/finance/finance-receipt/ApApplyTypeEnum',
        },
        {
          title: '回款状态',
          prop: 'repaymentStatus',
          dictionaryPath: '/finance/finance-receipt/ApApplyRepaymentStatusEnum',
        },
      ],
      tableColumn: [
        { prop: 'receiptNo', label: '收款单编号', minWidth: '1' },
        { prop: 'orderNumber', label: '业务订单编号', minWidth: '1' },
        { prop: 'applyNo', label: '申请编号', minWidth: '1' },
        { prop: 'cityName', label: '归属城市', minWidth: '1' },
        { prop: 'businessName', label: '采购商名称', minWidth: '1' },
        { prop: 'businessNo', label: '采购商编号', minWidth: '1' },
        { prop: 'applyType', label: '流水类型', minWidth: '1', slotName: 'applyTypeSlotName' },
        { prop: 'receiptAmount', label: '收款单金额', slotName: 'receiptAmountSlotName' },
        // 回款状态: NOT_REPAID 未回款,FULLY_REPAID 已回款
        { label: '回款状态', status: 'repaymentStatus', statusDesc: 'repaymentStatusDesc', statusColor: (val) => setStatusColor(val, 'repaymentStatus') },
        { prop: 'createTime', label: '创建时间', minWidth: '1', filterName: 'formatTime' },
        { prop: 'createUser', label: '申请人', minWidth: '1' },
      ],

      /** ------列表字段筛选---- */
      columnsKey: 'baibuBillDisburseList',
      selectTableColumn: [], // 显示的表头数据

      /** ------批量搜索开始---- */
      // 批量搜索搜索条件集合
      batchSearchTypeList: [
        { value: '1', label: '业务订单编号' },
        { value: '2', label: '收款单编号' },
        { value: '3', label: '申请编号' },
        { value: '5', label: '客户编号' },
      ],
      isBatchSearchShow: false, // 批量搜索
      batchResults: {}, // 批量操作返回结果
      isBatch: false, // 是否是批量操作
      /** ------批量搜索结束---- */
    };
  },
  computed: {
    exportParams() {
      const params = this.newAPiParam();
      delete params.page;
      delete params.limit;
      return params;
    },
    // 收款单金额为负，且高亮展示；
    isTextRed() {
      return (val) => {
        if (val && val < 0) {
          return true;
        }
        return false;
      };
    },
  },
  created() {
    this.init();
  },
  methods: {
    // 重置时间的默认值
    resetDate() {
      const { startDate, endDate } = getMonthDate();
      this.queryForm.beginTime = startDate || '';
      this.queryForm.endTime = endDate || '';
    },
    // 配置确认
    handleConfirm(values) {
      this.selectTableColumn = values;
      this.$nextTick(() => {
        this.$refs.baibuBillDisburseListRef.doLayout();
      });
    },
    // 批量查询提交
    handleBatchSearchConfirm(form) {
      const param = JSON.parse(JSON.stringify(queryFormDefault));
      param.searchBatchType = form.searchType || '';
      param.searchBatchContent = (form.list || []).join(',');
      this.queryForm = { ...param };
      this.getList(true);
    },
    // 批量查询弹窗
    handleBatchSearch() {
      this.isBatchSearchShow = true;
    },
    // 列表查询
    handleSearch(params = {}) {
      this.queryForm = { ...this.queryForm, ...params, page: 1 };
      this.getList();
    },
    // 重置搜索条件
    handleReset() {
      this.queryForm = JSON.parse(JSON.stringify(queryFormDefault));
      this.resetDate();
      this.getList();
    },
    refreshList() {
      this.queryForm.page = 1;
      this.getList();
    },
    // 分页操作
    handleCurrentChange(page) {
      this.queryForm.page = page;
      this.getList();
    },
    handleSizeChange(limit) {
      this.queryForm.page = 1;
      this.queryForm.limit = limit;
      this.getList();
    },
    // 处理提交接口的参数（列表/导出）
    newAPiParam() {
      const params = JSON.parse(JSON.stringify(this.queryForm));
      // 批量查询条件处理
      if (this.isBatch) {
        params.searchContent = params.searchBatchContent || '';
        params.searchType = params.searchBatchType || '';
      }
      delete params.timeType;
      delete params.searchBatchContent;
      delete params.searchBatchType;
      return params;
    },
    // 列表接口请求
    async getList(batch = false) {
      try {
        this.isBatch = batch;
        const params = this.newAPiParam();
        this.loading = true;
        this.list = [];
        const res = await getTradeList(params);
        this.total = res.totalCount || 0;
        this.list = res.data || [];
        this.isBatchSearchShow = false; // 批量搜索弹窗关闭
      } catch (error) {
        console.log(error);
        this.loading = false;
        this.list = [];
        this.total = 0;
      } finally {
        this.loading = false;
      }
    },
    async init() {
      try {
        this.resetDate();
        const list = await this.$store.dispatch('dictionary/getUserTemplate', {
          pageKeys: [this.columnsKey],
          columnsKey: this.columnsKey,
          tableColumn: this.tableColumn,
        });
        this.selectTableColumn = list;
      } catch (error) {
        this.selectTableColumn = this.tableColumn;
      }
      this.getList();
    },
  },
};
</script>
